export function BringSearchedToTop(
  listArray,
  collectItems,
  sortTarget,
  searchItems
) {
  // Create a Map to store the objects based on their Id
  const objectsMap = new Map(listArray?.map((obj) => [obj[sortTarget], obj]));

  // Create a new array to hold the sorted objects
  const sortedArray = [];

  // Add the matching objects to the sorted array
  for (const target of collectItems) {
    if (objectsMap.has(target)) {
      sortedArray.push(objectsMap.get(target));
      objectsMap.delete(target);
    }
  }

  // Add the searchItems objects to the sorted array
  if (searchItems) {
    for (const target of searchItems) {
      if (!collectItems.includes(target) && objectsMap.has(target)) {
        sortedArray.push(objectsMap.get(target));
        objectsMap.delete(target);
      }
    }
  }

  // Add the remaining objects to the sorted array
  sortedArray.push(...objectsMap.values());
  return sortedArray;
}
